function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClosenessS2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 273.971 273.971",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#351F10"
    },
    d: "M151.513,75.87c-2.009,6.831,16.811,22.99,16.811,22.99l43.283-17.174 c0,0,4.177-23.88-1.292-28.432C198.208,43.18,155.958,60.76,151.513,75.87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#351F10"
    },
    d: "M247.024,161.174l-18.846-44.669l45.792-12.686l-56.987,3.824l-32.339,14.875l-35.674,38.301 l37.401-22.244l12.906,39.824l7.405-2.327l9.992,47.122l-12.123,6.559l20.975-0.256c0,0-2.458-57.67-2.015-56.517 c0.444,1.153,6.732,56.235,6.732,56.235l20.439,0.151l-13.797-7.651l5.604-59.027L247.024,161.174z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E2D4BF"
    },
    points: "188.843,115.776 219.664,153.554 211.628,106.129  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EABB98"
    },
    d: "M224.598,80.514c-1.033-3.965-4.194-6.575-7.056-5.828c-1.153,0.301-2.078,1.105-2.709,2.212 c-6.254-4.477-13.924-14.669-29.78-6.901c-20.176,9.885-15.743,20.417-15.796,28.505c-1.86-0.604-3.705-0.404-4.96,0.725 c-2.202,1.975-1.77,6.05,0.967,9.097c2.737,3.051,6.741,3.919,8.944,1.942c0.339-0.302,0.606-0.659,0.822-1.05 c6.296,4.248,16.795,4.563,26.921,0.123c10.259-4.498,17.181-12.576,18.186-20.173c0.384,0.015,0.767-0.021,1.145-0.119 C224.147,88.296,225.629,84.479,224.598,80.514z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#351F10"
    },
    d: "M186.033,92.761c0.138,1.271-0.813,2.42-2.12,2.563c-1.311,0.142-2.487-0.775-2.626-2.047 c-0.139-1.272,0.813-2.421,2.123-2.564C184.717,90.571,185.895,91.487,186.033,92.761z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9941 -0.108 0.108 0.9941 -8.1746 22.2485)",
    style: {
      fill: "#351F10"
    },
    cx: 201.294,
    cy: 86.586,
    rx: 2.387,
    ry: 2.316
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#665E5A"
    },
    d: "M189.562,115.271l-8.794,5.785c0,0,20.77,30.183,38.348,32.255L189.562,115.271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#665E5A"
    },
    d: "M208.091,104.414l11.573,49.141c0,0,6.265-27.542,3.158-47.101L208.091,104.414z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7b96c4"
    },
    points: "199.983,109.954 184.617,108.594 192.305,124.541 201.38,113.006 216.359,115.308  209.852,98.989  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#351F10"
    },
    d: "M36.201,83.11c0,0-13.23-36.291,41.769-40.291l8.524,36.488L36.201,83.11z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#351F10"
    },
    d: "M85.287,169.522l-2.533-37.924l16.217,23.221L80.342,109.76l-39.4,1.289l-32.971,46.77 l30.805-27.039l-4.236,37.68l6.814,0.127l7.229,51.336l-12.309,9.127l18.667-1v-9.654c0,0,6.029-46.813,6.029-45.576 c0,1.236,0,54.93,0,54.93l21.02-0.236l-12.383-7.463l10.904-50.742L85.287,169.522z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E2D4BF"
    },
    points: "49.281,106.264 64.486,152.588 74.01,105.44  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EABB98"
    },
    d: "M94.311,86.188c0.459-4.072-1.555-7.643-4.494-7.973c-1.184-0.133-2.336,0.285-3.322,1.092 c-4.231-6.424-7.731-15.689-25.317-14.131C38.797,67.159,39.154,75.581,36.201,83.11c-1.52-1.231-3.313-1.707-4.889-1.104 c-2.765,1.053-3.824,5.012-2.363,8.838c1.46,3.83,4.885,6.078,7.65,5.023c0.425-0.16,0.803-0.398,1.145-0.686 c4.352,6.227,14.038,10.289,25.083,9.779c11.19-0.516,20.55-5.57,24.216-12.299c0.353,0.15,0.723,0.254,1.111,0.299 C91.096,93.29,93.85,90.258,94.311,86.188z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9667 0.2559 -0.2559 0.9667 23.2016 -11.9746)",
    style: {
      fill: "#351F10"
    },
    cx: 57.612,
    cy: 83.163,
    rx: 2.387,
    ry: 2.318
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9667 0.2559 -0.2559 0.9667 23.9083 -16.7658)",
    style: {
      fill: "#351F10"
    },
    cx: 76.38,
    cy: 83.489,
    rx: 2.387,
    ry: 2.317
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#665E5A"
    },
    d: "M50.133,106.051l-10.285,5.242c0,0,8.551,32.627,24.213,40.871L50.133,106.051z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#665E5A"
    },
    d: "M71.324,102.569l-6.838,50.019c0,0,15.733-23.457,19.855-42.828L71.324,102.569z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#351F10"
    },
    points: "61.768,104.829 47.914,98.043 49.365,115.688 61.977,108.18 75.131,115.706  74.916,98.137  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7b96c4"
    },
    points: "48.608,219.985 31.531,229.638 56.441,228.525 55.441,218.319  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7b96c4"
    },
    points: "71.437,219.94 60.471,218.319 60.471,228.254 85.878,227.992  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EABB98"
    },
    points: "121.376,139.806 124.466,227.064 128.072,227.064 130.132,154.01 132.708,226.557  135.799,226.557 139.92,139.806  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7b96c4"
    },
    points: "129.102,227.064 119.345,231.152 125.496,219.961 128.072,220.976  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7b96c4"
    },
    points: "131.678,227.064 142.495,230.152 135.284,219.961 132.708,220.976  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#351F10"
    },
    d: "M123.766,63.711c-14.328,3.683-31.237,15.294-26.785,36.002 c5.412,25.175,47.678,27.368,64.924,9.182c11.983-12.637-3.001-32.436-14.215-40.254 C139.539,62.958,131.235,61.791,123.766,63.711z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EABB98"
    },
    d: "M140.968,109.805c4.883-1.347,8.98-3.688,11.707-6.642c1.65-0.021,3.69-1.763,4.94-4.386 c1.489-3.126,1.288-6.309-0.447-7.108c-0.398-0.184-3.938-0.221-4.407-0.138c-2.188-7.609-12.307-13.364-24.469-13.364 c-10.859,0-16.999,4.592-20.41,10.993c-0.602-0.475-1.255-0.708-1.907-0.612c-1.896,0.275-3.033,3.174-2.536,6.476 c0.493,3.302,2.429,5.757,4.326,5.482c0.107-0.016,0.211-0.043,0.314-0.074c2.348,4.098,7.109,7.407,13.134,9.19l-21.244,45.195 l21.586-32.416l17.756-3.028l20.659,29.444L140.968,109.805z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7b96c4"
    },
    d: "M124.229,143.357l-3.703-25.043c0,0,6.858-4.315,9.341-4.36c2.755-0.047,10.476,4.36,10.476,4.36 l-4.224,24.929L124.229,143.357z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#351F10"
    },
    cx: 121.53,
    cy: 92.213,
    rx: 2.203,
    ry: 2.352
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#351F10"
    },
    cx: 140.223,
    cy: 93.259,
    rx: 2.202,
    ry: 2.353
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7b96c4"
    },
    d: "M99.74,188.585c0,0,3.09-46.673,32.227-45.839c25.485,0.729,33.708,42.796,33.708,42.796 S145.071,199.748,99.74,188.585z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.376,
    y: 137.854,
    style: {
      fill: "#665E5A"
    },
    width: 18.545,
    height: 7.103
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7b96c4"
    },
    d: "M151.768,82.048c1.191-0.755,4.863-3.706,2.863-5.247c-1.569-1.208-5.662,2.179-5.441,3.509 c0.028-1.721-0.574-5.665-2.958-4.332c-1.676,0.938-0.91,5.475,0.167,6.824c-1.21-1.923-5.968-1.714-6.358,0.279 c-0.676,3.472,4.748,3.607,6.888,2.384c-1.441,1.673-3.604,4.442-1.521,5.901c0.203,0.141,2.298,0.156,2.559,0.019 c0.672-0.354,1.275-1.382,1.531-2.343c0.197,1.594,0.938,3.425,2.406,3.26c2.99-0.337,1.922-5.907,0.815-7.202 c1.465,1.318,4.206,1.14,4.616-0.725C158.038,81.189,153.798,80.678,151.768,82.048z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#665E5A"
    },
    d: "M20.896,103.127h-1.142c0.044,5.862,0.987,14.248,3.694,26.236 c7.918,35.065-5.449,46.047-5.584,46.153l0.711,0.915c0.579-0.451,14.103-11.454,6.004-47.324 C21.869,117.115,20.945,108.833,20.896,103.127z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7b96c4"
    },
    d: "M39.626,73.66c-5.376-9.387-15.815-3.46-18.974,1.242C17.494,70.2,7.055,64.273,1.679,73.66 c-7.047,12.304,9.806,22.315,18.818,27.345c0,0,0.104,0.114,0.155,0.087c0.051,0.027,0.155-0.087,0.155-0.087 C29.82,95.975,46.672,85.963,39.626,73.66z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7b96c4"
    },
    points: "20.497,101.004 16.682,106.554 25.674,107.196  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosenessS2);
export default __webpack_public_path__ + "static/media/closenessS2.5fb254f4bfb23650469e2865943552cf.svg";
export { ForwardRef as ReactComponent };